<div  top="1" left="0" zIndex="2000" a-style bg="rgb(0,0,0,0.8)" display="grid" placeContent="center" position="fixed" h="100vh" w="100vw">
    <div a-style bg="#ffffff" p="2.5">
      <m-text  [type]="gs.enums.texts.heading2" text="Add Folder" mb="1.5"></m-text>
    </div>
</div>
